import { ModuleWithProviders, NgModule } from '@angular/core';
import { EmailDetailsComponent, EmailEditComponent } from '@spaq/modules/email/pages';
import { FormModule } from '@spaq/shared/components/forms';
import { SharedCommonModule } from '@spaq/shared/shared-common.module';
import { SharedComponentsModule } from '@spaq/shared/shared-components.module';
import { SharedFormModule } from '@spaq/shared/shared-form.module';
import { UpdateEmailComponent } from './components';

@NgModule({
	imports: [SharedCommonModule, FormModule, SharedComponentsModule, SharedFormModule],
	declarations: [EmailEditComponent, UpdateEmailComponent, EmailDetailsComponent],
	exports: [EmailEditComponent, UpdateEmailComponent, EmailDetailsComponent]
})
export class EmailModule {
	static forRoot(): ModuleWithProviders<EmailModule> {
		return {
			ngModule: EmailModule,
			providers: []
		};
	}
}
